import { apiErrorStrings } from "@/apis/apiError";

// Deleting a project that still holds files is deliberately refused by the API
// with a 400 and this detail. Detect it so we can explain the protection
// instead of reporting a generic failure.
export const isProjectNotEmptyError = (error: unknown): boolean =>
    apiErrorStrings(error).some(value => value.includes("contains files"));
